import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RechargeSpinResult } from "./types";

export enum RechargeSpinPhase {
  Idle = "idle",
  SpinningPendingResult = "spinningPendingResult",
  SpinningToResult = "spinningToResult",
  ResultDialogOpen = "resultDialogOpen",
  Rules = "rules",
}

export interface RechargeSpinUiState {
  phase: RechargeSpinPhase;
  result: RechargeSpinResult | null;
  finalRotation: number;
}

const initialState: RechargeSpinUiState = {
  phase: RechargeSpinPhase.Idle,
  result: null,
  finalRotation: 0,
};

const rechargeSpinSlice = createSlice({
  name: "rechargeSpin",
  initialState,
  reducers: {
    resetRechargeSpinUi: () => initialState,
    openRechargeSpinRules: (state) => {
      state.phase = RechargeSpinPhase.Rules;
    },
    closeRechargeSpinRules: (state) => {
      state.phase = RechargeSpinPhase.Idle;
    },
    startRechargeSpin: (state) => {
      if (
        state.phase === RechargeSpinPhase.SpinningPendingResult ||
        state.phase === RechargeSpinPhase.SpinningToResult
      ) {
        return;
      }

      state.phase = RechargeSpinPhase.SpinningPendingResult;
      state.result = null;
    },
    receiveRechargeSpinResult: (
      state,
      action: PayloadAction<RechargeSpinResult>
    ) => {
      state.phase = RechargeSpinPhase.SpinningToResult;
      state.result = action.payload;
    },
    showRechargeSpinResult: (state) => {
      if (!state.result) {
        state.phase = RechargeSpinPhase.Idle;
        return;
      }

      state.phase = RechargeSpinPhase.ResultDialogOpen;
    },
    closeRechargeSpinResult: (state) => {
      state.phase = RechargeSpinPhase.Idle;
      state.result = null;
    },
    failRechargeSpin: (state) => {
      state.phase = RechargeSpinPhase.Idle;
      state.result = null;
    },
    setRechargeSpinFinalRotation: (state, action: PayloadAction<number>) => {
      state.finalRotation = action.payload;
    },
  },
});

export const {
  resetRechargeSpinUi,
  openRechargeSpinRules,
  closeRechargeSpinRules,
  startRechargeSpin,
  receiveRechargeSpinResult,
  showRechargeSpinResult,
  closeRechargeSpinResult,
  failRechargeSpin,
  setRechargeSpinFinalRotation,
} = rechargeSpinSlice.actions;

export default rechargeSpinSlice.reducer;
